import { render } from "./CommissionsDetail.vue?vue&type=template&id=2da000f5&scoped=true"
import script from "./CommissionsDetail.vue?vue&type=script&lang=js"
export * from "./CommissionsDetail.vue?vue&type=script&lang=js"

import "./CommissionsDetail.vue?vue&type=style&index=0&id=2da000f5&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da000f5"]])

export default __exports__